import { createReducer, on } from '@ngrx/store';
import * as fromDirectDebitAutofill from '../actions/direct.debit.autofill.action';
import { StateSlice } from '@core/helpers/state-slice';

export type DirectDebitAutofillState = StateSlice<DirectDebitAutofill>;

export interface DirectDebitAutofill {
  reuse_dd_details: boolean;
  has_dd_details: boolean;
  payment_token: string;
}

export const initialState: DirectDebitAutofillState = {
  data: {
    reuse_dd_details: false,
    has_dd_details: false,
    payment_token: '',
  },
  loaded: false,
  loading: false,
  error: null,
};

const directDebitAutofillReducer = createReducer(
  initialState,
  on(fromDirectDebitAutofill.loadDirectDebitConfig, (state, { payload }) => {
    return {
      data: {
        ...state.data,
        reuse_dd_details: payload.reuse_dd_details,
        payment_token: payload?.payment_token,
        has_dd_details:
          payload.reuse_dd_details === true || state.data.has_dd_details,
      },
      loading: false,
      loaded: true,
      error: null,
    };
  })
);

export function reducer(
  state: DirectDebitAutofillState | undefined,
  action: fromDirectDebitAutofill.DirectDebitConfigActions
) {
  return directDebitAutofillReducer(state, action);
}
